import React, {useMemo, useState} from 'react';

import {useTranslation} from 'react-i18next';

import {ReactComponent as CheckIcon} from 'assets/svg/check2.svg';

import {Button} from 'components/ui-kit/Button';
import {Icon} from 'components/ui-kit/Icon';
import {Modal} from 'components/ui-kit/Modal';

import {breakpoint} from 'theme';

import {FormattedLabelsForm} from 'types';
import {useMatchMedia} from 'utils/custom-hooks';

import {
    ModalContent,
    OptionCard,
    OptionCards,
    OptionCheck,
    OptionLabel,
    StartButtonWrap,
} from './styled';

interface Props {
    show: boolean;
    onClose: () => void;
    onConfirm: (format: FormattedLabelsForm['pageFormat']) => void;
    specificFormat?: boolean;
}

export const OptionCheckComponent = () => (
    <OptionCheck>
        <Icon style={{marginLeft: '1px'}} source={CheckIcon} width={9} height={9} />
    </OptionCheck>
);

export const PrintModal: React.FC<Props> = ({show, onClose, onConfirm, specificFormat}) => {
    const {t: translation} = useTranslation();
    const PRINT_PATH = 'pages.orders.print';

    const mapping = useMemo<Partial<Record<FormattedLabelsForm['pageFormat'], string>>>(
        () => ({
            LETTER: 'letter',
            A4: 'a4',
            ...(!specificFormat && {
                STICKER_LARGE_H: 'largeHorizontal',
                STICKER_LARGE_V: 'largeVertical',
                STICKER_SMALL_H: 'smallHorizontal',
                STICKER_SMALL_V: 'smallVertical',
            }),
        }),
        [specificFormat],
    );
    const t = (key: string, vars?: Record<string, any>) =>
        translation(`${PRINT_PATH}.${key}`, vars ?? {});
    const [selected, setSelected] = useState<FormattedLabelsForm['pageFormat']>('LETTER');

    const isMobile = useMatchMedia(`(max-width: ${breakpoint.tablet})`);

    return (
        <Modal
            className="pick-print-format-options-modal"
            show={show}
            onClose={onClose}
            closable={true}
            hideCloseButton={false}
            modalWidth={isMobile ? 1 : 0}
            title={t('title')}
        >
            <ModalContent>
                <OptionCards>
                    {Object.entries(mapping).map(([format, path]) => (
                        <OptionCard
                            $selected={selected === format}
                            onClick={() => setSelected(format as FormattedLabelsForm['pageFormat'])}
                            type="button"
                        >
                            <OptionLabel>
                                <div>{t(path + '.label')}</div>
                                <span>{t(path + '.size')}</span>
                            </OptionLabel>
                            {selected === format && <OptionCheckComponent />}
                        </OptionCard>
                    ))}
                </OptionCards>
                <StartButtonWrap>
                    <Button onClick={() => onConfirm(selected)}>{t('submit')}</Button>
                </StartButtonWrap>
            </ModalContent>
        </Modal>
    );
};
